import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.99996 7.99935C7.26663 7.99935 6.63885 7.73824 6.11663 7.21602C5.5944 6.69379 5.33329 6.06602 5.33329 5.33268C5.33329 4.59935 5.5944 3.97157 6.11663 3.44935C6.63885 2.92713 7.26663 2.66602 7.99996 2.66602C8.73329 2.66602 9.36107 2.92713 9.88329 3.44935C10.4055 3.97157 10.6666 4.59935 10.6666 5.33268C10.6666 6.06602 10.4055 6.69379 9.88329 7.21602C9.36107 7.73824 8.73329 7.99935 7.99996 7.99935ZM2.66663 13.3327V11.466C2.66663 11.0882 2.76385 10.741 2.95829 10.4243C3.15274 10.1077 3.41107 9.86602 3.73329 9.69935C4.42218 9.3549 5.12218 9.09657 5.83329 8.92435C6.5444 8.75213 7.26663 8.66602 7.99996 8.66602C8.73329 8.66602 9.45552 8.75213 10.1666 8.92435C10.8777 9.09657 11.5777 9.3549 12.2666 9.69935C12.5888 9.86602 12.8472 10.1077 13.0416 10.4243C13.2361 10.741 13.3333 11.0882 13.3333 11.466V13.3327H2.66663Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPerson);
export default ForwardRef;
